
<img
  src="../../../../images/icons/ic_check.svg"
  alt="入力状態"
  class="u-w20 u-h20 u-rounded"
  :class="{
    'u-bg-main': isCompleted,
    'u-bg-base3': !isCompleted,
  }"
/>
